import React, { useEffect, useState } from "react";
import { FieldWrapper, FieldActionWrapper, SelectField } from "@factorearth/component-library";
import { FieldInstance, FieldTemplate, Option } from "db/definitions";
import { Colors } from "@factorearth/component-library/dist/Theme/types";
import Svg from "../../Svg/Svg";
import { recordSentry } from "utils/recordSentry";

interface RadioFieldProps {
	color: Colors;
	fieldInstance: FieldInstance;
	fieldTemplate: FieldTemplate;
	value: string;
	fromTable?: boolean;
	moreHorizon?: JSX.Element;
	handleChange: (event: { target: { value: string } }) => void;
}

const RadioField = (props: RadioFieldProps) => {
	const { color, fieldInstance, fieldTemplate, value, handleChange, fromTable, moreHorizon } = props;
	const [selectedValue, setSelectedValues] = useState<Option[]>([]);
	const [sortedOptions, setSortedOptions] = useState<Option[]>([]);

	useEffect(() => {
		if (!fieldTemplate.options?.items || !fieldTemplate.optionsOrder) return;
		const optionMap: Map<string, Option> = new Map();
		for (const option of fieldTemplate.options.items) {
			optionMap.set(option.id, option);
		}
		const options: Option[] = [];
		for (let i = 0; i < fieldTemplate?.optionsOrder?.length; i++) {
			const optionId = fieldTemplate.optionsOrder[i];
			const option = optionMap.get(optionId);
			if (option) {
				options.push(option);
			} else {
				recordSentry({
					error: new Error(
						`RadioField: Option with id ${optionId} not found in options map. FieldTemplate: ${fieldTemplate.id} FormTemplate: ${fieldTemplate.formTemplate}, Field: ${fieldInstance.id} (${fieldTemplate.header})`,
					),
					msg: "RadioField option not found",
				});
			}
		}
		setSortedOptions(options);
	}, []);

	useEffect(() => {
		setSelectedValues(sortedOptions.filter((option) => option.id === value));
	}, [sortedOptions, value]);

	const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSelectedValues(sortedOptions.filter((option) => option.id === e.target.id));

		const optionEvent = {
			target: { value: e.target.value === "NONE" ? "" : e.target.id },
		};

		handleChange(optionEvent);
	};

	return (
		<FieldWrapper
			colorPalette={color}
			label={!fromTable ? fieldTemplate.header : undefined}
			link={fieldInstance.altInstanceId ? <Svg icon="LINKED" /> : undefined}
			data-fieldtemplateid={fieldTemplate.id}>
			<FieldActionWrapper>
				<SelectField
					handleChange={handleRadioChange}
					values={selectedValue}
					colorPalette={color}
					moreHorizon={moreHorizon ? moreHorizon : undefined}
					options={sortedOptions}
					type="radio"
					label={fieldTemplate.header}
				/>
			</FieldActionWrapper>
		</FieldWrapper>
	);
};

export default RadioField;
